/**
 * FTO 搜索权限策略
 * @module fto-search-strategy
 */

import { UsageService } from '@/domains/credit/services/usage-service';
import { BasePermissionStrategy } from '@/domains/shared/strategies/base-permission-strategy';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FeatureKey } from '@telecom/shared/domain/permission';

/**
 * FTO 搜索权限策略
 */
@injectable()
export class FtoSearchStrategy extends BasePermissionStrategy {
    readonly featureId: FeatureKey = 'FTO:Create';

    protected _hasUsage(usageService: UsageService): boolean {
        return usageService.hasFtoSearchUsage;
    }
}
